import { isAuthorizedUser } from 'shared/hooks/use-user'
import { UnauthorizedUser, UserInterface } from 'shared/types/user-interface'

export const determineTimezone = (
  user: UserInterface | UnauthorizedUser | undefined,
): string | undefined => {
  try {
    // Try to get browser timezone first
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch (e) {
    // Fallback to user timezone if available
    return isAuthorizedUser(user) ? user.timezone : undefined
  }
}
